export default "__VITE_ASSET__xtKGYbpG__"